import { render, staticRenderFns } from "./Metaliens.vue?vue&type=template&id=3502e4df&scoped=true&"
import script from "./Metaliens.vue?vue&type=script&lang=js&"
export * from "./Metaliens.vue?vue&type=script&lang=js&"
import style0 from "./Metaliens.vue?vue&type=style&index=0&id=3502e4df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3502e4df",
  null
  
)

export default component.exports